/**
 * æ¯ä¸éé¡¹çåå®¹
 */
export class MultiScaleOption {
  linkName = '';
  constructor(public parentId: number = -1,
              public id: number = -2,
              public name: string = '',
              public choice: boolean = false) {
    this.parentId = this.parentId || -1;
    this.id = this.id === 0 ? 0 : this.id || -2;
    this.name = this.name || '';
  }

  isEmpty() {
    return this.id === -2;
  }

}

